'use strict';
const angular = require('angular');

export function pinnedItemsService($localStorage) {
  'ngInject';

  let typeMap = {
    "wo": "workItems",
    "ccr": "workItems",
    "sr": "workItems",

    "project": "projects",

    "community": "portfolio",
    "property": "portfolio",
    "contact": "portfolio",
    "vendor": "portfolio",
    "webaccess": "portfolio",
    "custom": "portfolio"
  };

  let toggleInStore = (type, item) => {
    let id = item.id;
    let collection = typeMap[type];
    let idx = $localStorage.pinned[collection].findIndex(storageItem => {return storageItem.id == item.id});
    
    if (idx == -1) {    // item not in store --> add it
      $localStorage.pinned[collection].push(item);
    } else { // item was already there --> remote it
      $localStorage.pinned[collection].splice(idx, 1);
    }
  };

  let typeUrlMap = {
    "wo": "/workorder/ticket/detail/",
    "sr": "/servicerequest/ticket/detail/",
    "ccr": "/violation/ticket/detail/",

    "community": "/community/",
    "property": "/property/",
    "contact": "/contact/",
    "vendor": "/vendor/",
    "webaccess": "/webaccess/",
    "custom": "/custom/"

  };

  if (!$localStorage.pinned)
    $localStorage.pinned = {};

  if (!$localStorage.pinned.workItems)
    $localStorage.pinned.workItems = [];

  if (!$localStorage.pinned.projects)
    $localStorage.pinned.projects = [];

  if (!$localStorage.pinned.portfolio)
    $localStorage.pinned.portfolio = [];

  return {
    
    workItems: $localStorage.pinned.workItems,
    projects: $localStorage.pinned.projects,
    portfolio: $localStorage.pinned.portfolio,

    isPinnedWorkItem(id) {
      return ($localStorage.pinned.workItems.findIndex(item => {return item.id == id}) !== -1);
    },

    toggleWorkItem(id, type, name) {
      toggleInStore(type, {
        id: id,
        name: name,
        path: typeUrlMap[type] + id
      })
    },

    isPinnedProject(id) {
      return ($localStorage.pinned.projects.findIndex(item => {return item.id == id}) !== -1);
    },

    toggleProject(id, name) {
      toggleInStore("project", {
        id: id,
        name: name,
        path: "/project/" + id
      })
    },


    isPinnedPortfolio(id) {
      return ($localStorage.pinned.portfolio.findIndex(item => {return item.id == id}) !== -1);
    },

    togglePortfolio(id, type, name) {
      toggleInStore(type, {
        id: id,
        name: name,
        path: typeUrlMap[type] + id
      })
    },

    toggleCustomPortfolio(id, type, customType, name) {
      toggleInStore(type, {
        id: id,
        name: name,
        path: typeUrlMap[type] + customType + "/" +  id
      })
    }

  };
}


export default angular.module('conduu.pinnedItems', [])
  .factory('PinnedItems', pinnedItemsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/pinned-items/pinned-items.service.js